import type { LoadableType } from '@confluence/loadable';
import { LoadableLazy } from '@confluence/loadable';
import type { GuestRequestToUpgradeLearnMoreModalProps } from '../src/guest-request-upgrade/GuestRequestToUpgradeLearnMoreModal.tsx';

export const GuestRequestToUpgradeDialog: LoadableType<GuestRequestToUpgradeLearnMoreModalProps> =
	LoadableLazy({
		loader: async () =>
			(
				await import(
					/* webpackChunkName: "loadable-GuestRequestToUpgradeLearnMoreModal" */ '../src/guest-request-upgrade/GuestRequestToUpgradeLearnMoreModal.tsx'
				)
			).GuestRequestToUpgradeLearnMoreModal,
	});
